/**
 * @const {object}
 * @memberOf module:policies
 */
export const pnpDocumentEventActions = {
    /* @ngInject */
    controller: function () {
        /**
         * @function $onInit
         */
        this.$onInit = () => {}
    },

    template: `<pnp-document-event-actions-grid></pnp-document-event-actions-grid>`
};
